import React from 'react';
import './Gallery.css';
import img1 from '../../images/gallery/1.jpg';
import img2 from '../../images/gallery/2.jpg';
import img3 from '../../images/gallery/3.jpg';
import img4 from '../../images/gallery/4.jpg';
import img5 from '../../images/gallery/5.jpg';
import img6 from '../../images/gallery/6.jpg';
import { Helmet } from 'react-helmet';




const Gallery = () => {

 const images = [img1 ,img2,img3,img4,img5,img6 ];

return (
    <>
      <Helmet>
        <title>Our Galleryy</title>
        <meta name="description" content="Our WOrk" />
        <meta name="keywords" content="about, company, mission, team" />
      </Helmet>
      <section className="gallery">
      {images.map((src, index) => (
        <div className="gallery-item" key={index}>
          <img src={src} alt={`Gallery ${index + 1}`} loading="lazy" />
        </div>
      ))}
    </section>
    </>
  );
 
  


};



export default Gallery;
